import { create } from "zustand";


export interface ISearchFieldState {
    isSearchFieldFocused: boolean,
    setSearchFieldFocused: (isSearchFieldFocused: boolean) => void,
}

const useSearchFieldState = create<ISearchFieldState>((set) => ({

    isSearchFieldFocused: false,
    setSearchFieldFocused: (isSearchFieldFocused: boolean) => set({ isSearchFieldFocused }),

}));

export default useSearchFieldState;